"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("@styled-system/prop-types"));

var _icon = _interopRequireDefault(require("../../components/icon"));

var _validationIcon = _interopRequireDefault(require("./validation-icon.style"));

var _inputBehaviour = require("../input-behaviour");

var _utils = require("../../style/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const marginPropTypes = (0, _utils.filterStyledSystemMarginProps)(_propTypes2.default.space);

const getValidationType = ({
  error,
  warning,
  info
}) => {
  if (error) return "error";
  if (warning) return "warning";
  if (info) return "info";
  return "";
};

const ValidationIcon = ({
  error,
  warning,
  info,
  size,
  onFocus,
  onBlur,
  iconId,
  isPartOfInput,
  tabIndex,
  onClick,
  tooltipPosition,
  tooltipFlipOverrides,
  ...rest
}) => {
  const {
    hasFocus,
    hasMouseOver
  } = (0, _react.useContext)(_inputBehaviour.InputContext);
  const {
    hasFocus: groupHasFocus,
    hasMouseOver: groupHasMouseOver
  } = (0, _react.useContext)(_inputBehaviour.InputGroupContext);
  const [triggeredByIcon, setTriggeredByIcon] = (0, _react.useState)(false);
  const validationType = getValidationType({
    error,
    warning,
    info
  });
  const validationMessage = error || warning || info;

  if (typeof validationMessage !== "string") {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(_validationIcon.default, _extends({
    id: iconId,
    validationType: validationType,
    role: "tooltip",
    "aria-label": validationMessage,
    onClick: onClick,
    onMouseOver: () => setTriggeredByIcon(true),
    onMouseLeave: () => setTriggeredByIcon(false),
    onFocus: e => {
      setTriggeredByIcon(true);
      if (onFocus) onFocus(e);
    },
    onBlur: e => {
      setTriggeredByIcon(false);
      if (onBlur) onBlur(e);
    }
  }, (0, _utils.filterStyledSystemMarginProps)(rest)), /*#__PURE__*/_react.default.createElement(_icon.default, {
    key: `${validationType}-icon`,
    type: validationType,
    tabIndex: tabIndex,
    tooltipMessage: validationMessage,
    tooltipPosition: tooltipPosition,
    tooltipVisible: hasFocus || hasMouseOver || groupHasFocus || groupHasMouseOver || triggeredByIcon,
    tooltipFlipOverrides: isPartOfInput && !tooltipFlipOverrides ? ["top", "bottom"] : tooltipFlipOverrides,
    isPartOfInput: isPartOfInput,
    inputSize: size
  }));
};

ValidationIcon.propTypes = { ...marginPropTypes,

  /** A small string to indicate the size of the icon */
  size: _propTypes.default.oneOf(["small", "medium", "large"]),

  /** The unique id of the component (used with aria-describedby for accessibility) */
  iconId: _propTypes.default.string,

  /** Define position of the tooltip */
  tooltipPosition: _propTypes.default.string,

  /** Overrides the default flip behaviour of the Tooltip, must be an array containing some or all of ["top", "bottom", "left", "right"] (see https://popper.js.org/docs/v2/modifiers/flip/#fallbackplacements) */
  tooltipFlipOverrides: (props, propName, componentName) => {
    const prop = props[propName];
    const isValid = prop && Array.isArray(prop) && prop.every(placement => ["bottom", "left", "right", "top"].includes(placement));

    if (!prop || isValid) {
      return null;
    }

    return new Error( // eslint-disable-next-line max-len
    `The \`${propName}\` prop supplied to \`${componentName}\` must be an array containing some or all of ["top", "bottom", "left", "right"].`);
  },

  /** An onClick handler */
  onClick: _propTypes.default.func,

  /** An onFocus handler */
  onFocus: _propTypes.default.func,

  /** An onBlur handler */
  onBlur: _propTypes.default.func,

  /** A boolean to indicate if the icon is part of an input */
  isPartOfInput: _propTypes.default.bool,

  /** Overrides the default tabindex of the component */
  tabIndex: _propTypes.default.number,

  /** Status of error validations */
  error: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /** Status of warnings */
  warning: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /** Status of info */
  info: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string])
};
ValidationIcon.defaultProps = {
  tooltipPosition: "right",
  tabIndex: -1
};
var _default = ValidationIcon;
exports.default = _default;